import {utils, writeFileXLSX} from "xlsx"

export default function exportExcel(data, fileName) {
  const ws = utils.json_to_sheet(data);
  const wb = utils.book_new();
  utils.book_append_sheet(wb, ws, "Data");
  writeFileXLSX(wb, `service_me_${fileName}.xlsx`);
}
